import React from "react";
import Reveal from "./Reveal";
import { impactStats, clientLogos } from "../mock";

const ImpactSection = () => {
  return (
    <section className="bg-[#F6F7F9] py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal className="mb-4 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E4545F]">
            Impact
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#0F2A4A] md:text-4xl">
            Two decades of measurable results
          </h2>
        </Reveal>

        {/* Stats */}
        <Reveal>
          <div className="grid grid-cols-2 gap-6 border-y border-slate-200 py-12 md:grid-cols-4">
            {impactStats.map((s) => (
              <div key={s.label} className="text-center md:text-left">
                <div className="font-serif-display text-4xl text-[#0F2A4A] md:text-5xl">
                  {s.value}
                </div>
                <div className="mt-2 text-sm text-slate-500">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Client logos — soft-white monochrome, colour on hover */}
        <Reveal className="mt-14">
          <p className="mb-8 text-center text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">
            Trusted by companies, governments &amp; institutions worldwide
          </p>
          <div
            className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7"
            data-testid="client-logos"
          >
            {clientLogos.map((logo) => (
              <div
                key={logo.name}
                data-testid={`client-logo-${logo.name}`}
                title={logo.name}
                className="group flex h-24 items-center justify-center rounded-xl bg-white px-5 shadow-[0_8px_28px_-20px_rgba(15,42,74,0.4)] ring-1 ring-slate-100"
              >
                <img
                  src={logo.src}
                  alt={logo.name}
                  loading="lazy"
                  className="max-h-12 w-auto max-w-full object-contain opacity-60 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0"
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ImpactSection;
